module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('vbl-tab-group', {
    attrs: {
      "selected-index": _vm.index
    },
    on: {
      "update:selectedIndex": function($event) {
        _vm.index = $event
      }
    }
  }, [_c('vbl-tab', {
    attrs: {
      "label": "标题1"
    }
  }, [_vm._v("内容1")]), _c('vbl-tab', {
    attrs: {
      "label": "标题2"
    }
  }, [_vm._v("内容2")]), _c('vbl-tab', {
    attrs: {
      "label": "标题3"
    }
  }, [_vm._v("内容3")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b47bc65","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vblTab/example/vblTabExample.vue
// module id = 247
// module chunks = 0